import type { PropsWithChildren } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

import { StyledCrmEnrichmentJobReviewBlockWrapper, StyledCrmEnrichmentJobReviewBlock } from "./styles";

type Props = PropsWithChildren<{
    titleKey: string;
    onEdit: VoidFunction;
}>;

const CrmEnrichmentJobReviewBlock = ({ titleKey, onEdit, children }: Props) => (
    <StyledCrmEnrichmentJobReviewBlockWrapper>
        <StyledCrmEnrichmentJobReviewBlock>
            <Text
                as="h3"
                fontVariant="subsectionTitle"
                color={colorsPalettes.carbon[500]}
                margin="8px 0 16px"
            >
                {translate(titleKey)}
            </Text>

            {children}
        </StyledCrmEnrichmentJobReviewBlock>

        <Button
            type="flat"
            onClick={onEdit}
        >
            {translate("common.edit")}
        </Button>
    </StyledCrmEnrichmentJobReviewBlockWrapper>
);

export default CrmEnrichmentJobReviewBlock;
